import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  standalone: true,
  name: 'messageDate',
})
export class MessageDatePipe implements PipeTransform {
  transform(date: Date | string): string {
    date = new Date(date);
    const today = new Date();

    return new DatePipe('en').transform(
      date,
      date.toDateString() === today.toDateString() ? 'HH:mm' : 'dd.MM.yyyy',
    );
  }
}
